<script>
import { Cell, Popup, Picker } from 'vant'
import ObjectFunc from '@/tbs/util/ObjectFunc'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'picker-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-popup': Popup,
        'van-picker': Picker
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        id: String,
        label: String,
        options: Array,
        value: String,
        index: Number,
        keyword: String,
        disabled: Boolean,
        clearable: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
    emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: false,
            // selectedOptionLabel: null,
            selectedOption: null,
            selectedIndex: null,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the area value to display on the cell item.
         */
        optionLabel() {
            let selectedLabel = ''       
            if (this.selectedOption) {
                const prop = this.getKeywordLabel()
                selectedLabel = this.selectedOption[prop]
            }
            return selectedLabel
        },
        keywordLabel() {
            return this.getKeywordLabel()
        }
    },

    watch: {
        value(value) {
            // console.log('watch updated value setter', value, this.options)
            this.updateValue(value)
        }
    },

    mounted() {
        // console.log('mounted updated value setter', this.value, this.options)
        this.updateValue(this.value)
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onOptionPickerConfirm(data) {
            this.selectedOption = data
            this.showPopup = false
            if (this.id) {
                data.id = this.id
            }
            this.$emit('change-data', data)
        },
        onOptionLinkClick() {
            if (!this.disabled) {
                this.showPopup = true
            }
        },
        onClearBtnClick() {
            if (!this.disabled) {
                const data = {}
                if (this.id) {
                    data.id = this.id
                }
                this.selectedOption = null
                this.$emit('change-data', data)
            }
        },
        getKeywordLabel() {
            return this.keyword ? this.keyword : 'label'
        },
        updateValue(value) {
            if (value == null) {
                this.selectedOption = null
                this.selectedIndex= null
                return
            }
            for (let i = 0; i < this.options.length; i++) {
                let option = this.options[i]
                if (option.value == value) {
                    this.selectedOption = ObjectFunc.cloneObject(option)
                    this.selectedIndex = i
                    return
                }
            }
        },
    },
}
</script>

<template>
    <!-- component -->
    <div class="picker-selector van-cell no-padding">
        <van-cell 
            :class="{ disabled: disabled }"
            :title="label"
            :value="optionLabel"
            center
            @click="onOptionLinkClick"
        >
            <template #right-icon>
                <div v-if="!disabled" class="l-inner-margin minor-color">
                    <div v-if="clearable">
                        <van-icon 
                            v-if="selectedOption" 
                            name="clear"
                            size="16"
                            @click.stop="onClearBtnClick"
                        />
                        <van-icon v-else name="arrow"/>
                    </div>
                    <div v-else>
                        <van-icon name="arrow"/>
                    </div>
                </div>
            </template>
        </van-cell>
        <van-popup v-model="showPopup" position="bottom">
            <van-picker
                :title="label"
                :columns="options"
                :default-index="selectedIndex || index"
                :value-key="keywordLabel"
                show-toolbar
                @cancel="showPopup = false"
                @confirm="onOptionPickerConfirm"
            />
        </van-popup>
    </div>
</template>